<aside *ngIf="settings.bannerText" [class]="settings.bannerText">
  {{ settings.bannerText }}
</aside>
